import * as types from './types';
import { createCoverageReducers } from '../../../common/coverage/reducers';
import { VdcBrowserCoverageRecord } from '../../../../records';

const { initialState, reducer } = createCoverageReducers({
  types,
  CoverageRecord: VdcBrowserCoverageRecord,
});

export default reducer;
export { initialState };
